import { TextField, TextFieldProps } from "@mui/material";
import { Controller, Control, FieldPath, FieldValues } from "react-hook-form";

interface FormTextFieldProps<T extends FieldValues>
  extends Omit<TextFieldProps, "name" | "value" | "onChange"> {
  name: FieldPath<T>;
  control: Control<T>;
  label: string;
  placeholder?: string;
  type?: string;
  required?: boolean;
}

export const FormTextField = <T extends FieldValues>({
  name,
  control,
  label,
  placeholder,
  type = "text",
  required = false,
  ...textFieldProps
}: FormTextFieldProps<T>) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <TextField
          {...field}
          {...textFieldProps}
          label={label}
          placeholder={placeholder}
          type={type}
          error={!!error}
          helperText={error?.message || textFieldProps.helperText}
          required={required}
          variant={textFieldProps.variant || "standard"}
        />
      )}
    />
  );
};
